module.exports = __webpack_public_path__ + "static/img/page19.cb57044.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page19.jpg
// module id = 8Bgx
// module chunks = 0